module.exports = __webpack_public_path__ + "img/20191213165351470.1770eee2.jpg";